module.exports = __webpack_public_path__ + "img/20210730_213353.f4fe0eb6.jpg";